"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = exports.PRICE_STYLE_TYPE = exports.PRICE_SIZE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Tax = require("./Tax");
var _Value = require("./Value");
require("./Price.scss");
var PRICE_SIZE = /*#__PURE__*/function (PRICE_SIZE) {
  PRICE_SIZE["default"] = "default";
  PRICE_SIZE["small"] = "small";
  return PRICE_SIZE;
}(PRICE_SIZE || {});
exports.PRICE_SIZE = PRICE_SIZE;
var PRICE_STYLE_TYPE = /*#__PURE__*/function (PRICE_STYLE_TYPE) {
  PRICE_STYLE_TYPE["default"] = "default";
  PRICE_STYLE_TYPE["discount"] = "discount";
  PRICE_STYLE_TYPE["secondary"] = "secondary";
  return PRICE_STYLE_TYPE;
}(PRICE_STYLE_TYPE || {});
exports.PRICE_STYLE_TYPE = PRICE_STYLE_TYPE;
var Price = function Price(_ref) {
  var _classNames;
  var className = _ref.className,
    currency = _ref.currency,
    price = _ref.price,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? PRICE_SIZE["default"] : _ref$size,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? PRICE_STYLE_TYPE["default"] : _ref$styleType;
  var Value = Price.Value;
  if (typeof price == 'undefined' || price === null) {
    return null;
  }
  var rootClassName = (0, _classnames["default"])('cds-Price', (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "cds-Price--".concat((0, _upperCaseFirst.upperCaseFirst)(size || '')), size !== PRICE_SIZE["default"]), (0, _defineProperty2["default"])(_classNames, "cds-Price--".concat((0, _upperCaseFirst.upperCaseFirst)(styleType || '')), styleType !== PRICE_STYLE_TYPE["default"]), _classNames), className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement(Value, {
    currency: currency,
    price: price
  }), children);
};
exports.Price = Price;
Price.Tax = _Tax.Tax;
Price.Value = _Value.Value;
Price.config = {
  size: PRICE_SIZE,
  styleType: PRICE_STYLE_TYPE
};